// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://cszulqxzroqgdrzmtith.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNzenVscXh6cm9xZ2Ryem10aXRoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDIxNjU3MDIsImV4cCI6MjA1Nzc0MTcwMn0.GeGNV91Xn9g56WEHAz8mLcH9yrrxu9cEkgjZnMkpvOY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);